var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      addBtn: _vm.hasBtn("add-admin-leave-transaction-policy"),
      title: _vm.$t("label_essweb_leaveTransactionPropertyGroup_list_title"),
      pad: "0",
      filterable: "",
      exportBtn: _vm.hasBtn("export-admin-leave-transaction-policy"),
      importBtn: _vm.hasBtn("import-admin-leave-transaction-policy"),
      "import-options": {
        api: "/leave-transaction-type-property-group/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/leave-transaction-type-group-import-template.xlsx",
        success: function (result) {
          _vm.getList(null, 1, _vm.$tableSetting.perPageSize, null)
        },
      },
    },
    on: {
      activated: _vm.activated,
      new: _vm.toNew,
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                "filter-page-data": _vm.filterPageData,
                showSelect: _vm.showSelect,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.leave_transaction_type_property_group_name
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.leave_transaction_type_property_group_name
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "text--primary table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.leave_transaction_type_property_group_code
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn(
                            "delete-admin-leave-transaction-policy"
                          ),
                          editBtn: _vm.hasBtn(
                            "edit-admin-leave-transaction-policy"
                          ),
                          viewBtn: _vm.hasBtn(
                            "view-admin-leave-transaction-policy"
                          ),
                          title: _vm.$t(
                            "label_essweb_leaveTransactionPropertyGroup_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }